module.exports = __webpack_public_path__ + "static/Carly_Daniel8-be9b9a81750f066eed29fe45f5ed1250.jpg";